<template>
    <div class="mb-6 d-inline-block position-relative dm-wrap-illustration">
        <div class="dm-custom-cover">
            <img :src="presentation.custom_cover_image_url" />

            <button
                class="btn btn-sm btn-icon btn-light-danger dm-delete-illustration"
                @click="deleteCoverImage()"
            >
                <i class="icon-lg las la-times"></i>
            </button>
        </div>
    </div>
</template>

<script>
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapWritableState } from "pinia";

export default {
    computed: {
        ...mapWritableState(useSubmissionWizardStore, ["presentation"]),
    },

    methods: {
        deleteCoverImage() {
            var self = this;
            axios
                .delete(
                    "/api/author/presentations/" +
                        this.presentation.id +
                        "/cover-image",
                )
                .then(function (response) {
                    self.replaceCoverProps(response.data);
                    self.showSwalSuccessPopup();
                });
        },

        // NOTE: These come from the Presentation Presenter, so they 100% match what we already have on the presentation
        // Consider moving to store, as it's shared.
        replaceCoverProps(data) {
            this.presentation.cover_image_type = data.cover_image_type;
            this.presentation.cover_image_url = data.cover_image_url;
            this.presentation.custom_cover_image_url =
                data.custom_cover_image_url;
            this.presentation.has_cover_image = data.has_cover_image;
            this.presentation.has_custom_cover_image =
                data.has_custom_cover_image;
        },
    },
};
</script>
